export default __webpack_public_path__ + "static/media/untitled-41.c37dde68.jpg";